import gql from 'graphql-tag';
import { sessionFieldsFragment } from '@graphql/admin/fragments';

export const addSessionMutation = gql`
  mutation AddSession($input: CreateSessionInput!) {
    addSession(input: $input) {
      ...AdminSessionFields
    }
  }

  ${sessionFieldsFragment}
`;